import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AppToastrService {
  constructor(private toastr: ToastrService) {}

  clear(clear: boolean = true) {
    if (clear) {
      this.toastr.clear();
    }
  }

  error(message, clear: boolean = true) {
    this.clear(clear);
    this.toastr.error(message);
  }

  success(message, clear: boolean = true) {
    this.clear(clear);
    this.toastr.success(message);
  }

  info(message, clear: boolean = true) {
    this.clear(clear);
    this.toastr.info(message);
  }

  warning(message, clear: boolean = true) {
    this.clear(clear);
    this.toastr.warning(message);
  }
}
